import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26c37108"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createElementVNode("span", null, "HONG KONG")
], -1))
const _hoisted_5 = { class: "tips" }
const _hoisted_6 = { class: "agree" }
const _hoisted_7 = { class: "proto" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "I have read and agreed", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " that Fusion Bank will send the delivery information to Tesla for delivery arrangement", -1))

import { reactive, onBeforeMount } from 'vue';
import { TLayout, TForm, TFormItem, TInput, TCheckbox, TButton } from '@tencent/web-vbui';
import { spin } from '@tencent/web-vbui/src/components/t-spin/spin';
import { toast } from '@tencent/web-vbui/dist/components/t-toast/toast';
import { navigator } from '@tencent/vb-app-bridge';
import { i18n, reportStatistics } from '@tencent/vb-web-base';
import { baseMixins } from '@common/mixins/baseMixins';
import { getUserAdr } from '@common/core/network/NodeAPI';
import { UseAward } from '../../core/network/NodeAPI';
import { NetworkError } from '@common/lib/error';
import Contract from '@tencent/vb-web-contract';
import { getQuery } from '@tencent/multi-url';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComfirmAddress',
  setup(__props) {

const { recordNo } = getQuery();
const { showModalError, showLoading, isEng, setTitle } = baseMixins();
const { getT } = i18n;
const $t = getT();
setTitle($t('送货资料'));
const formData = reactive({
  isChecked: false,
  name: '',
  mobile: '',
  address: '',
});

const contractInstance = new Contract({
  key: 'DeliveryPICS',
  autoSign: false,
  containerType: 'dialog',
  needAgree: false,
  needCheckBox: false,
  hideBtn: true,
  needTitle: false,
});

const checkProto = () => {
  contractInstance.preview();
};

// const isBtnDisabled = computed(() => !formData.isChecked );

const submit = async () => {
  if (!formData.isChecked) {
    toast.show({
      title: $t('您尚未同意隐私条款'),
      timeout: 1000,
    });
    return;
  }
  try {
    spin.show();
    reportStatistics({
      evtName: 'comfirmAddress',
      desc: '收货信息页面确认按钮点击',
    });
    await contractInstance.sign();
    await UseAward({ recordNo: recordNo as string });
    navigator.back();
    spin.hide();
  } catch (err) {
    const error = err as NetworkError;
    showModalError(error.message, error.code);
  }
  spin.hide();
};

// 获取用户信息
async function getUserInfo() {
  showLoading(true);
  try {
    const data = await getUserAdr();
    formData.address = data.residenceAddress;
    formData.name = isEng.value ? data.enName : data.name;
    formData.mobile = data.mobile;
  } catch (err) {
    const error = err as NetworkError;
    showModalError(error.message, error.code);
  }
  showLoading(false);
}

const goModify = async () => {
  await navigator.invoke('/e/my/profile.html/address?type=2');
  getUserInfo();
};

onBeforeMount(() => {
  getUserInfo();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TLayout), { "is-copyright": false }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref($t)('请确认您的送货资料')), 1),
        _createVNode(_unref(TForm), null, {
          default: _withCtx(() => [
            _createVNode(_unref(TFormItem), {
              prop: "name",
              label: _unref($t)('收货人姓名')
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(TInput), {
                  disabled: "",
                  modelValue: formData.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(TFormItem), {
              prop: "mobile",
              label: _unref($t)('联系电话1')
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(TInput), {
                  disabled: "",
                  modelValue: formData.mobile,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.mobile) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(TFormItem), {
              class: "address",
              prop: "address",
              label: _unref($t)('送货地址'),
              "is-auto-height": true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _withDirectives(_createElementVNode("textarea", {
                    rows: "3",
                    disabled: "",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.address) = $event))
                  }, null, 512), [
                    [_vModelText, formData.address]
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, _toDisplayString(_unref($t)(
                '送货地址默认为您于本行预留的联络地址。若您希望更换送货地址，请先更换您于本行的联络地址，随后送货地址将自动更新。',
              )), 1),
          _createElementVNode("a", { onClick: goModify }, _toDisplayString(_unref($t)('前往更改联络地址')), 1)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(TCheckbox), {
          modelValue: formData.isChecked,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.isChecked) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_7, [
          (!_unref(isEng))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", null, _toDisplayString(_unref($t)('本人阅读并同意富融银行将送货资料传送至Tesla以作送货安排的')), 1),
                _createElementVNode("a", { onClick: checkProto }, _toDisplayString(_unref($t)('隐私条款')), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_8,
                _createElementVNode("a", { onClick: checkProto }, " the Privacy Agreement"),
                _hoisted_9
              ], 64))
        ])
      ]),
      _createVNode(_unref(TButton), {
        theme: "primary",
        onClick: submit,
        text: _unref($t)('确认并完成领取')
      }, null, 8, ["text"])
    ]),
    _: 1
  }))
}
}

})